import React from "react";
import { Dialog } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import ReceiptPaymentOrder from "./ReceiptPaymentOrder";

const ReceiptPaymentDialog = ({ open, onClose, data }) => {
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          backgroundColor: "transparent",
          boxShadow: "none",
          borderRadius: 0,
        },
      }}
      BackdropProps={{
        sx: {
          background: isDark ? "rgba(0,0,0,0.60)" : "rgba(255,255,255,0.10)",
          backdropFilter: "blur(8px)",
          WebkitBackdropFilter: "blur(8px)",
        },
      }}
    >
      <ReceiptPaymentOrder data={data} />
    </Dialog>
  );
};

export default ReceiptPaymentDialog;
